var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import StyledText from "./styles";
export var Text = function (props) {
    var _a = props.renderAs, renderAs = _a === void 0 ? "span" : _a, color = props.color, align = props.align, textStyle = props.textStyle, forceMobile = props.forceMobile, textStyles = props.textStyles, colors = props.colors, other = __rest(props, ["renderAs", "color", "align", "textStyle", "forceMobile", "textStyles", "colors"]);
    return (_jsx(StyledText, __assign({}, other, { as: renderAs, "$color": color, "$align": align, "$textStyle": textStyle, "$forceMobile": forceMobile, "$textStyles": textStyles, "$colors": colors })));
};
Text.defaultProps = {
    renderAs: "span",
    textStyle: "body1",
    align: "none",
    forceMobile: false,
};
